import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useD3BarChart from './useD3BarChart';
import './CryptoMarkets.css';

/**
 * CryptoMarkets component displays a horizontal bar chart of crypto consumer markets
 * 
 * @param {Object} props - Component props
 * @param {Array} props.data - Data array with country and value properties
 * @param {Object} props.options - Optional configuration for the chart
 * @param {boolean} props.loading - Loading state
 * @param {string} props.className - Additional CSS class
 * @returns {JSX.Element} - Rendered component
 */
const CryptoMarkets = ({ 
  data = [], 
  options = {}, 
  loading = false,
  className = ''
}) => {
  // Default data if none provided
  const [chartData, setChartData] = useState([]);
  
  // Set up the D3 chart reference
  const svgRef = useD3BarChart(chartData, options);
  
  // Update chart data when props change
  useEffect(() => {
    if (data && data.length > 0) {
      setChartData(data);
    } else {
      // Default data if none provided
      setChartData([
        { country: "País 1", value: 100000 },
        { country: "País 2", value: 90000 },
        { country: "País 3", value: 80000 },
        { country: "País 4", value: 70000 },
        { country: "Brasil", value: 60000 },
        { country: "País 6", value: 50000 },
        { country: "País 7", value: 40000 },
        { country: "País 8", value: 30000 },
        { country: "País 9", value: 20000 },
        { country: "País 10", value: 10000 }
      ]);
    }
  }, [data]);
  
  // If loading, show loading state
  if (loading) {
    return (
      <div className={`crypto-markets-container ${className}`}>
        <div className="crypto-markets-loading">
          Carregando dados...
        </div>
      </div>
    );
  }
  
  return (
    <div className={`crypto-markets-container ${className}`}>
      <svg 
        ref={svgRef} 
        className="crypto-markets-chart"
        preserveAspectRatio="xMinYMin meet"
      />
    </div>
  );
};

CryptoMarkets.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      country: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ),
  options: PropTypes.object,
  loading: PropTypes.bool,
  className: PropTypes.string
};

export default CryptoMarkets;
